import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { debounceTime, startWith, map } from 'rxjs';
import { StringService } from 'src/app/commons/string.service';
import { StaticDataService } from 'src/app/data/static-data.service';

@Component({
  selector: 'app-campo-categorias',
  templateUrl: './campo-categorias.component.html',
  styleUrls: ['./campo-categorias.component.css']
})
export class CampoCategoriasComponent implements OnInit {
  @Input() formulario: UntypedFormGroup;
  @Input() descricao: string = '';
  @Input() tipo: string = 'text';
  @Input() modoInsercao: string = 'text';
  @Input() nomeControle: string;
  @Input() autoPreenchimento: string = 'off';
  @Input() identificacao: string;
  @Input() textoAjuda: string;
  @Input() classe: string;

  @Output() alteracao = new EventEmitter();

  categorias: Array<any>;
  opcoesFiltradas: any;

  // Propriedades para controlar a exibição
  opcoesParaExibir: any[] = [];
  mostrandoTodas: boolean = false;
  mostrarBotaoVerMais: boolean = false;
  totalOpcoesFiltradas: number = 0;
  opcoesFiltradas_: any[] = []; // Array para armazenar as opções filtradas

  private readonly LIMITE_INICIAL = 5;

  constructor(
    private staticService: StaticDataService,
  ) { }

  ngOnInit(): void {
    this.staticService.categorias().toPromise()
    .then(response => {
      this.categorias = response.body;
      this.opcoesFiltradas = this.formulario.controls[this.nomeControle].valueChanges.pipe(
        debounceTime(100),
        startWith(''),
        map((value: string) => {
          const filtradas = this._filter(value);
          this.atualizarExibicao(filtradas);
          return filtradas;
        }),
      );
    })
  }

  change() {
    this.alteracao.emit();
  }

  _filter(value: any): any[] {
    let filterValue = null;

    if (typeof value === 'string') {
      filterValue = value;
    } else {
      filterValue = value?.descricao;
    }

    if (!filterValue || filterValue.trim().length <= 2) {
      return [];
    }

    const categoriasFiltradas = this.categorias.filter(option =>
      StringService.normalize(option.descricao).includes(StringService.normalize(filterValue))
    );

    // Ordenar em ordem alfabética
    categoriasFiltradas.sort((a: any, b: any) => a.descricao.localeCompare(b.descricao));

    return categoriasFiltradas;
  }

  private atualizarExibicao(opcoesFiltradas: any[]): void {
    this.opcoesFiltradas_ = opcoesFiltradas;
    this.totalOpcoesFiltradas = opcoesFiltradas.length;

    // Resetar estado quando há nova busca
    this.mostrandoTodas = false;

    // Verificar se deve mostrar o botão "Ver mais"
    this.mostrarBotaoVerMais = opcoesFiltradas.length > this.LIMITE_INICIAL;

    // Definir quais opções exibir
    if (this.mostrandoTodas || opcoesFiltradas.length <= this.LIMITE_INICIAL) {
      this.opcoesParaExibir = opcoesFiltradas;
    } else {
      this.opcoesParaExibir = opcoesFiltradas.slice(0, this.LIMITE_INICIAL);
    }
  }

  toggleVerMais(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.mostrandoTodas = !this.mostrandoTodas;

    if (this.mostrandoTodas) {
      this.opcoesParaExibir = this.opcoesFiltradas_;
    } else {
      this.opcoesParaExibir = this.opcoesFiltradas_.slice(0, this.LIMITE_INICIAL);
    }
  }

  displayCategoria(value: any): string {
    if(!value) return ''
    return `${value.descricao}`
  }
}
